import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Angular's built-in Validators.email accepts addresses with no top-level
 * domain at all (e.g. "user@gmail" passes), because its domain segment
 * is optional. This validator additionally requires a proper ".tld"
 * (2+ letters) so addresses like "user@gmail" or "user@gmail." are rejected.
 * Uses the 'email' error key so existing fieldError() messages keep working.
 */
export const EMAIL_REGEXP =
  /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

export function properEmailValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value ?? '';
  if (!value) return null;

  return EMAIL_REGEXP.test(value) ? null : { email: true };
}
